import {createFormActions, createFormActionTypes} from "@pg-mono/form";
import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {IArticleCommentFormValues} from "../components/comments/ArticleCommentForm";

export interface IPostArticleComment {
    nick_name?: string;
    text: string;
    article: number;
}

const ARTICLE_COMMENT = "article/POST_COMMENT";
export const articleCommentFormTypes = createFormActionTypes(ARTICLE_COMMENT);
export const articleCommentFormActions = createFormActions(articleCommentFormTypes);

export const postArticleComment = (jsonData: Partial<IArticleCommentFormValues & {article: number}>) => {
    return postRequest({}, apiPath.comments.article.base, jsonData).then((result: IArticleCommentFormValues) => {
        return result;
    });
};
